// Variant id → body component. Split across files by data source so the
// modules stay small: planning reads the calendar/todo/shopping tree,
// finance the budget tree, activity the fitness/time/diary tree, and async
// fetches from the lib modules that don't live in `data` at all.

import { PLANNING_BODIES } from './bodies/planning';
import { FINANCE_BODIES } from './bodies/finance';
import { ACTIVITY_BODIES } from './bodies/activity';
import { ASYNC_BODIES } from './bodies/async';

export const WIDGET_BODIES = {
  ...PLANNING_BODIES,
  ...FINANCE_BODIES,
  ...ACTIVITY_BODIES,
  ...ASYNC_BODIES
};

export const getWidgetBody = (variantId) => WIDGET_BODIES[variantId] || null;
